import React, { useRef } from 'react';
import { content } from '../data/content';
import { useReveal } from '../hooks/useReveal';
import ProjectCard from '../components/ProjectCard';

const Projects = ({ language }) => {
    const t = content[language].projects;
    const root = useRef(null);

    useReveal(root);

    return (
        <div ref={root} className="min-h-screen pt-24 pb-16 px-4 container mx-auto">
            <h1 className="reveal text-4xl font-bold text-center mb-12 text-gray-800 dark:text-white">
                {t.title}
            </h1>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                {t.items.map((project) => (
                    <ProjectCard
                        key={project.id}
                        title={project.title}
                        subtitle={project.subtitle}
                        desc={project.desc}
                        tech={project.tech}
                        status={project.status}
                        state={project.state}
                        icon={project.icon}
                        color={project.color}
                        href={project.link || undefined}
                        actionLabel={t.actions.view}
                        moreLabel={t.actions.more}
                        lessLabel={t.actions.less}
                    />
                ))}
            </div>
        </div>
    );
};

export default Projects;
